<template>
  <div class="tile is-child box is-info notification">
    <div @click="isModalActive = true">
      <div class="columns is-mobile level">
        <span class="column time level-item">{{departTime}}</span>
        <span class="column price level-item">{{price}}</span>
        <span class="column time level-item">{{arriveTime}}</span>
      </div>
      <icon-segments :departTime=departTime :arriveTime=arriveTime :permutation=itinerary.permutation></icon-segments>

    </div>

    <b-modal class="is-fullwidth" :active.sync="isModalActive">
      <itinerary-modal v-on:add-to-cart="addToCart" :itinerary=itinerary></itinerary-modal>
    </b-modal>
  </div>


</template>

<script>
  import IconSegments from './IconSegments';
  import ItineraryModal from './ItineraryModal';
  import format from 'date-fns/format'
  export default {
    name: 'Itinerary',
    props: ['itinerary'],
    components: {
      'icon-segments': IconSegments,
      'itinerary-modal': ItineraryModal,
    },
    data() {
      return {
        isModalActive: false,
      };
    },
    computed: {
      departTime: function () {
        let segs;
        if (this.itinerary.departing_segments.length > 0) {
          segs = this.itinerary.departing_segments
        }
        else {
          segs = this.itinerary.returning_segments;
        }
        return format(segs[0].depart_time, 'hh:mma')
      },
      arriveTime: function () {
        let segs;
        if (this.itinerary.departing_segments.length > 0) {
          segs = this.itinerary.departing_segments
        }
        else {
          segs = this.itinerary.returning_segments;
        }
        return format(segs[segs.length - 1].arrive_time, 'hh:mma')
      },
      price: function () {
        if (this.itinerary && this.itinerary.total_price) {
          return `$${parseFloat(this.itinerary.total_price).toFixed(2)}`
        }
        return ''
      }
    },
    methods: {
      addToCart() {
        this.$emit('add-to-cart', this.itinerary)
        this.isModalActive = false;
      },
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .itinerary {
    border: 1px solid #eee;
    border-radius: 5px;
  }

  .time {
    font-size: 18px;
  }

  .price {
    font-size: 24px;
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// src/components/Itinerary.vue